import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import { IconHistory01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';

import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** imgSrc */
  imgSrc?: string;
  /** rs */
  rs?: string;
  /** onClick */
  onClick?: () => void;
}

const HistoryBtn = ({ className, imgSrc, rs, onClick }: IProps) => {
  const cName = classNameBind([
    'history-btn',
    imgSrc ? 'is-history' : '',
    className || '',
  ]);

  return (
    <S.HistoryBtn className={cName} onClick={onClick} label="최근 본 상품">
      {imgSrc ? (
        <Img
          src={getResizeImageUrl(imgSrc, rs)}
          priority
          errorImg="//static.wconcept.co.kr/display/images/no_image.png"
        />
      ) : (
        <IconHistory01 />
      )}
    </S.HistoryBtn>
  );
};

export default HistoryBtn;
